module.exports = __webpack_public_path__ + "static/media/karosserie-fachbetrieb.3087e5bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/logos/leiste/karosserie-fachbetrieb.jpg
// module id = 608
// module chunks = 0